export default "__VITE_ASSET__5d8563ed__"